<template>
	<div v-if="size === 'small'" class="stock-row-small">
		<div class="stock-status">
			<span :class="stockClass"></span>
		</div>
		<div class="stock-location">
			{{ storeName }}
		</div>
	</div>
	<div v-else-if="size === 'large'" class="stock-row-large">
		<div v-if="showFavouriteMark" class="stock-select">
			<label v-if="canAddFavouriteMark" class="stock-favorite" :title="favouriteTitle">
				<input type="checkbox" v-model="inUserSelection"><span/>
			</label>
			<span v-else style="margin-left:14px;" />
		</div>
		<div class="stock-location">
			{{ storeName }}
			<span v-if="storeIsPickupPoint" class="store-pickup-point">
				Pick-Up Point
			</span>
		</div>
		<div class="stock-status">
			<div :class="stockClass"></div>
			<strong>
				<span class="stock-text">
					{{ stockText }}
					<preorder-info v-if="! isReleased" />
				</span>
				<span class="additional-stock-text">
					{{ stockTextExtra }}
				</span>
			</strong>
		</div>
	</div>
	<div v-else class="stock-row">
		<div v-if="showFavouriteMark" class="stock-select mr-3">
			<label v-if="canAddFavouriteMark" class="stock-favorite" :title="favouriteTitle">
				<input type="checkbox" v-model="inUserSelection"><span />
			</label>
			<span v-else style="margin-left:14px;" />
		</div>
		<div class="stock-location">
			{{ storeName }}
			<span v-if="storeIsPickupPoint" class="store-pickup-point">
				Pick-Up Point
			</span>
		</div>
		<div class="stock-status">
			<div :class="stockClass" >
			</div>
			<span class="stock-text">
				{{ stockText }}
				<preorder-info v-if="! isReleased" />
			</span>
			<span class="additional-stock-text">
				{{ stockTextExtra }}
			</span>
		</div>
	</div>
</template>

<script>
import store from 'datastore';
import { t, storeName } from 'datastore/i18n';
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';
import { shouldShowStock } from 'utils';
import { mapGetters } from 'vuex';

const STOCK_STATUS_CL_OK = 1;
const STOCK_STATUS_CL_EMPTY = 2;

export default {
	store,
	props: {
		'stock': {
			type: [Object, Array],
			required: true,
		},
		'release': {
			// Timestamp and format.
			type: Object,
		},
		'store': {
			type: [Number, String],
			required: true,
		},
		'size': {
			type: String,
		},
		'name': {
			type: String,
			default: null,
		},
		'noStar': {
			default: false,
		},
		'product': {
			type: Object,
		},
	},
	data () {
		return {
			stockText: '',
			stockTextExtra: '',
			stockStatus: STOCK_STATUS_CL_OK,
			stockClass: {
				'stock-icon-instock': true,
			},
		};
	},
	methods: {
		ts: t.prefix('STOCK'),
	},
	computed: {
		shouldShowStock() {
			return shouldShowStock(this.product, this.user);
		},
		showFavouriteMark () {
			return this.noStar === false;
		},
		inUserSelection: {
			get () {
				return this.$store.state.userSettings.myStores.indexOf(this.store) >= 0;
			},
			set (checked) {
				const index = this.$store.state.userSettings.myStores.indexOf(this.store);
				if (checked && index < 0) {
					this.$store.dispatch('userSettings/addStore', this.store);
				} else if (! checked && index >= 0) {
					this.$store.dispatch('userSettings/removeStore', this.store);
				}
			},
		},
		canAddFavouriteMark () {
			if (this.store === 9999) { // @TODO övriga butiker, övergå till att använda strängar
				return false;
			}
			return ! (isNaN(this.store) || (this.favouriteMarkCount >= 3 && ! this.inUserSelection));
		},
		favouriteMarkCount () {
			return this.$store.state.userSettings.myStores.length;
		},
		storeName () {
			if (this.name) {
				return this.name;
			}
			if (this.store === 'other_stores') {
				return this.ts('OTHER_STORES');
			}
			if (this.store === 'supplier') {
				return this.ts('AT_SUPPLIER');
			}
			if (this.store === 'download') {
				return this.ts('DOWNLOAD');
			}
			return storeName(this.store);
		},
		storeIsPickupPoint () {
			if (typeof this.stores[this.store] != "undefined" && this.stores[this.store].isPickupPoint) {
				return true;
			}
		},
		favouriteTitle () {
			return this.ts('STAR');
		},
		...mapState({
			userSettings: state => state.userSettings,
			user: state => state.user,
		}),
		...mapGetters({
			stores: "i18n/stores",
		}),
		isReleased () {
			return stockUtils.isReleased(this.release);
		},
	},
	mounted () {
		let ret = null;
		if (this.shouldShowStock) {
			ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size);
		} else {
			ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size, this.product.statusCodes);
		}
		this.stockText = ret.stockText;
		this.stockTextExtra = ret.stockTextExtra;
		this.stockStatus = ret.stockStatus;
		this.stockClass = ret.stockClass;
	},
	watch: {
		store (to) {
			let ret = null;
			if (this.shouldShowStock) {
				ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size);
			} else {
				ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size, this.product.statusCodes);
			}
			this.stockText = ret.stockText;
			this.stockTextExtra = ret.stockTextExtra;
			this.stockStatus = ret.stockStatus;
			this.stockClass = ret.stockClass;
		},
		stock () {
			let ret = null;
			if (this.shouldShowStock) {
				ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size);
			} else {
				ret = stockUtils.calculateStockStatus(this.store, this.stock, this.userSettings, this.release, this.size, this.product.statusCodes);
			}
			this.stockText = ret.stockText;
			this.stockTextExtra = ret.stockTextExtra;
			this.stockStatus = ret.stockStatus;
			this.stockClass = ret.stockClass;
		},
	},
};
</script>
